import { Component, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { KEYWORD_QUERYSTRING_NAME, SEARCH_RESULTS_URL } from '@search/services';
import { KeyboardNavigationTargetDirective } from '@core/accessibility';

@Component({
  selector: 'wl-search-suggestion',
  standalone: true,
  imports: [FontAwesomeModule, RouterModule, KeyboardNavigationTargetDirective],
  templateUrl: './search-suggestion.component.html',
  styleUrls: ['./search-suggestion.component.essent.scss'],
})
export class SearchSuggestionComponent {
  readonly searchResultsPage = SEARCH_RESULTS_URL;

  readonly basePath = inject(ENVIRONMENT_CONFIG).basePath;

  readonly query = input.required<string>();
  readonly value = input<string>();

  /**
   * Maps a query to a spec compliant query string for search.
   * @param query search query
   * @returns queryParams object containing the querystring param for the search service
   */
  params(query: string) {
    return { [KEYWORD_QUERYSTRING_NAME]: query };
  }
}
